import { Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Log } from 'src/app/core/console.log';
import { DropdownModel } from 'src/app/models/master/dropdown-model';
import { MasterService } from 'src/app/services/master.service';
import { inputMgsErrs } from 'src/app/validators/message-validation';
import { DropdownFormControl } from '../dropdown-form-control';

@Component({
  selector: 'app-input-dp-occupation',
  templateUrl: './input-dp-occupation.component.html',
  styleUrls: ['./input-dp-occupation.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDpOccupationComponent),
      multi: true
    }
  ]
})
export class InputDpOccupationComponent extends DropdownFormControl implements OnInit {
  @Input() label: any;
  @Input() excludeCode: any = false;
  errors = inputMgsErrs.occupation;
  productCodeforSingleMode: any;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer,
    private translate: TranslateService,
    private masterService: MasterService
  ) {
    super(cc);
  }

  ngOnInit() {
    this.checkInitialControl();
    this.initDropdownList();
  }

  protected filterSearchItemCustom(search: string, item: DropdownModel): boolean {
    return super.filterSearchItemCustom(search, item)
      || (item.data.code ? item.data.code.search(search) !== -1 : false);
  }

  initDropdownList() {
    this.productCodeforSingleMode = sessionStorage.getItem('productCodeforSingleMode')
    if (this.productCodeforSingleMode !== undefined && this.productCodeforSingleMode !== null) {
      if (this.productCodeforSingleMode == "1LP") {
        this.resetDropdownList();
        this.masterService.getOccupationForSingle(this.excludeCode).subscribe(result => {
          this.items.push(...result);
          this.findValueFromList(this.value);
          this.setAfterLoadItemDropdown();
        }, error => {
          Log.error(error);
        });
      } else {
        this.resetDropdownList();
        this.masterService.getOccupation(this.excludeCode).subscribe(result => {
          this.items.push(...result);
          this.findValueFromList(this.value);
          this.setAfterLoadItemDropdown();
        }, error => {
          Log.error(error);
        });
      }
    } else {
      this.resetDropdownList();
      this.masterService.getOccupation(this.excludeCode).subscribe(result => {
        this.items.push(...result);
        this.findValueFromList(this.value);
        this.setAfterLoadItemDropdown();
      }, error => {
        Log.error(error);
      });
    }

  }

  resetDropdownList() {
    this.items = new Array<DropdownModel>();
    // this.translate.get('input.dropdown.select.default').subscribe(label => {
    //   this.items.push({ value: null, label: label, data: null });
    // });
  }
}
